// extracted by mini-css-extract-plugin
export default {"profile":"profile-desc-tab_profile__Lr+tD","fadeIn":"profile-desc-tab_fadeIn__zbKkc","active":"profile-desc-tab_active__mFpid"};